module.exports = __webpack_public_path__ + "media/images/bnr-firefox-e849968350f559f1c52d7bed6d54ddfb.svg";